import React from "react";
import GameCard from "../components/GameCard";
const GAMES = require("../data/games.json");

function HeroBanner() {
    const top_game = Object.values(GAMES).sort((a, b) => b.rating - a.rating)[0];
    return (
        <div className="relative bg-gradient-to-br from-[#6366f1] via-[#8b5cf6] via-[#a855f7] to-[#ec4899] overflow-hidden rounded-b-3xl border-b-4 border-[#fbbf24]/60 shadow-2xl shadow-[#8b5cf6]/50">
            {/* Cosmic nebula overlay */}
            <div className="absolute inset-0 bg-gradient-to-tr from-[#3b82f6]/20 via-transparent to-[#f472b6]/20"></div>
            <div className="absolute inset-0 bg-gradient-to-bl from-[#fbbf24]/10 via-transparent to-[#06b6d4]/10"></div>
            
            {/* Space decorations */}
            <div className="absolute top-4 left-4 text-4xl animate-bounce-joy">🎮</div>
            <div className="absolute top-8 right-8 text-3xl animate-float">✨</div>
            <div className="absolute bottom-4 left-8 text-3xl animate-wiggle">🎯</div>
            <div className="absolute bottom-8 right-4 text-4xl animate-bounce-joy" style={{ animationDelay: '1s' }}>🌟</div>
            <div className="absolute top-1/2 left-1/4 text-2xl animate-twinkle">💫</div>
            <div className="absolute top-1/3 right-1/4 text-2xl animate-float" style={{ animationDelay: '0.5s' }}>🌌</div>
            
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    <div>
                        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-2 drop-shadow-lg animate-bounce-joy bg-gradient-to-r from-[#fef3c7] via-white to-[#fef3c7] bg-clip-text text-transparent">JoyLoom Games</h1>
                        <div className="w-20 h-1 bg-gradient-to-r from-[#fbbf24] via-[#ec4899] to-[#3b82f6] mb-4 rounded-full shadow-lg shadow-[#8b5cf6]/60"></div>
                        <p className="mt-4 text-white/95 max-w-xl text-justify leading-relaxed">JoyLoom Games is a creative mobile game developer and publisher focused on delivering engaging, high-quality entertainment experiences for global audiences. With a passion for innovation and player satisfaction, JoyLoom Games specializes in designing fun, accessible, and visually appealing titles that combine strong gameplay with cultural and emotional depth. The studio's mission is to connect players through memorable gaming moments while supporting talented developers to bring their ideas to life.</p>
                        <div className="mt-6 flex gap-3">
                            {/* <Link to="/" className="px-4 py-2 rounded-full bg-blue-600 hover:bg-blue-700">Browse games</Link>
                            <a href="#" className="px-4 py-2 rounded-full border border-white/10">Upload game</a> */}
                        </div>
                    </div>
                    {/* <Link to= className="group block bg-gradient-to-br from-[#021428] to-[#011428] rounded-xl overflow-hidden shadow-md hover:shadow-xl transform hover:-translate-y-1 transition"> */}
                    <div className="hidden sm:block">
                        <div className="bg-gradient-to-br from-[#6366f1]/50 via-[#8b5cf6]/40 via-[#ec4899]/40 to-[#3b82f6]/50 p-4 rounded-2xl shadow-2xl border-4 border-[#fbbf24]/60 backdrop-blur-sm joy-hover">
                            <img src="/images/hero-banner.png" alt="preview" className="w-full object-cover rounded-md" />
                            <div className="mt-3 text-white font-semibold text-center">Discover the Future of Mobile Gaming</div>
                            <div className="text-[#fef3c7] text-sm text-center">★ ★ ★</div>
                        </div>
                    </div>
                    {/* </Link> */}
                </div>
            </div>
        </div>
    );
}

function Home() {
    return (
        <div className="pt-20 pb-24">
            <HeroBanner />
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <section className="mt-12">
                    <div className="flex items-center gap-3 mb-4">
                        <h2 className="text-2xl font-semibold text-white drop-shadow-lg">Popular Games</h2>
                        <span className="text-2xl animate-bounce-joy">🎮</span>
                    </div>
                    <p className="text-white/90 mt-2">Discover and download top mobile titles — curated picks every week.</p>

                    <div className="mt-6 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-6 max-w-md mx-auto">
                        {Object.values(GAMES).map((g) => (
                            <GameCard key={g.id} game={g} />
                        ))}
                    </div>
                </section>
            </main>
        </div>
    );
}

export default Home;